import React from 'react'

const CardShape = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="143.5" height="99.4" viewBox="0 0 205 142" fill="none" {...props}>
    <rect width="205" height="142" rx="9" fill="url(#paint0_linear)" />
    <rect x="151" y="56" width="36" height="28" rx="3" fill="#AFB0AF" />
    <rect x="165.5" y="66.5" width="8" height="8" stroke="#5D625F" />
    <path
      d="M178 56v28M160 56v28M178 64h9M151 64h9M154 71h5.5M178 76h5.5"
      stroke="#5D625F"
    />
    <mask
      id="mask0"
      x="0"
      y="0"
      width="205"
      height="142"
      maskUnits="userSpaceOnUse">
      <rect width="205" height="142" rx="9" fill="#535554" />
    </mask>
    <g mask="url(#mask0)" stroke="#AFB0AF" strokeLinejoin="round">
      <path d="M37.413 54V-2.842L63.648 25.142 37.413 54Z" />
      <path d="M31 19.895V-18L48.49.656 31 19.895Z" />
      <path d="M49.073 25.142V-2.842L61.899 10.935 49.073 25.142Z" />
      <path d="M52.571 9.984V-18l12.826 13.777L52.571 9.984Z" />
      <path d="M125.413 178v-56.842l26.235 27.984-26.235 28.858Z" />
      <path d="M119 143.895V106l17.49 18.656L119 143.895Z" />
      <path d="M137.073 149.142v-27.984l12.826 13.777-12.826 14.207Z" />
      <path d="M140.571 133.984V106l12.826 13.777-12.826 14.207Z" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-9"
        y1="86.5"
        x2="213"
        y2="0"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#24482F" />
        <stop offset="0.475" stopColor="#5B9B42" />
        <stop offset="0.8727" stopColor="#24482F" />
      </linearGradient>
    </defs>
  </svg>
)

export default CardShape
